<template>
  <teleport to="body">
    <div class="risk-notice-backdrop">
      <div
        class="risk-notice-dialog"
        role="alertdialog"
        aria-modal="true"
        :aria-labelledby="titleId"
      >
        <header class="risk-notice-header">
          <span class="risk-badge">!</span>
          <h2 :id="titleId">{{ title }}</h2>
        </header>
        <ul class="risk-notice-list">
          <li v-for="(message, index) in messages" :key="index">
            {{ message }}
          </li>
        </ul>
        <button class="risk-notice-button" type="button" @click="$emit('close')">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { computed } from 'vue';

defineProps({
  title: {
    type: String,
    required: true
  },
  messages: {
    type: Array,
    default: () => []
  },
  confirmText: {
    type: String,
    required: true
  }
});

const titleId = computed(() => `risk-notice-title-${Math.random().toString(36).slice(2, 10)}`);
</script>

<style scoped>
.risk-notice-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1.5rem;
}

.risk-notice-dialog {
  background: #fff7d6;
  border: 1px solid #facc15;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
  max-width: 460px;
  width: 100%;
  padding: 2.2rem 2rem 2rem;
  color: #854d0e;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.risk-notice-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.risk-notice-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
}

.risk-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: #facc15;
  color: #78350f;
  font-weight: 700;
  font-size: 1.25rem;
}

.risk-notice-list {
  margin: 0;
  padding: 0 0 0 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-size: 1rem;
  line-height: 1.6;
}

.risk-notice-button {
  align-self: flex-end;
  padding: 0.6rem 1.4rem;
  border-radius: 999px;
  border: none;
  background: linear-gradient(120deg, #f59e0b 0%, #f97316 100%);
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 12px 22px rgba(249, 115, 22, 0.28);
}

.risk-notice-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 28px rgba(249, 115, 22, 0.32);
}

.risk-notice-button:active {
  transform: translateY(0);
  box-shadow: 0 8px 16px rgba(249, 115, 22, 0.24);
}

@media (max-width: 600px) {
  .risk-notice-dialog {
    padding: 1.8rem 1.5rem;
  }

  .risk-notice-header h2 {
    font-size: 1.3rem;
  }
}
</style>
